import React from "react";
import Modal from "react-modal";
import Skeleton from "react-loading-skeleton";
import * as Icon from "react-feather";
import * as Spinner from "react-loader-spinner";

export default function DeleteConfirmModal({
  DeleteModalView,
  SetDeleteModalView,
  HeadingText,
  BodyText,
  ConfirmHandler,
  ConfirmHandlerArgs,
  WarningText,
  strictDelete,
  onErrorText,
  ...props
}) {
  const [confirmProcessing, setConfirmProcessing] = React.useState(false);
  const [showStrictError, setShowStrictError] = React.useState(false);
  const [displayError, setDisplayError] = React.useState(false);

  React.useEffect(() => {
    setConfirmProcessing(!DeleteModalView);
    setShowStrictError(false);
    setDisplayError(false);
  }, [DeleteModalView]);

  return (
    <Modal
      isOpen={DeleteModalView}
      closeTimeoutMS={100}
      className="relative w-full h-full grow px-4 overflow-x-hidden overflow-y-visible bg-black bg-opacity-50 z-50 backdrop-blur-sm"
    >
      <div
        tabIndex="-1"
        aria-hidden="true"
        className="flex flex-col grow space-y-0 w-full md:h-full my-4 md:my-0 md:p-4 overflow-x-visible md:inset-0 items-center justify-center"
      >
        <div className="flex flex-col relative w-full max-w-md h-auto">
          {/* <!-- Modal content --> */}

          <div className="relative bg-white border-2 border-slate-100 rounded-xl shadow-[0_0_10px_rgba(0,0,0,0.3)]">
            <div className="px-6 py-6 lg:px-8">
              {/* <h3 className="mb-4 text-xl font-medium text-gray-900 dark:text-white">Authenticate Card</h3> */}
              <h3 className="mb-1 text-xl sm:text-2xl font-semibold text-gray-900">
                {HeadingText !== undefined ? (
                  HeadingText
                ) : (
                  <Skeleton />
                )}
              </h3>
              {showStrictError ? (
                <div className="pt-2">
                  <p className="mb-4 text-sm font-semibold text-white bg-red-500 rounded-lg p-3">Unable to Proceed: Confirmation field is not YES</p>
                </div>
              ) : null}
              {displayError && onErrorText ? (
                <div className="pt-2">
                  <p className="mb-4 text-sm font-semibold text-white bg-red-500 rounded-lg p-3">{onErrorText}</p>
                </div>
              ) : null}
              <h3 className="mb-4 text-sm sm:text-1xl font-normal text-slate-500">
                {BodyText !== undefined ? (
                  BodyText
                ) : (
                  <Skeleton />
                )}
              </h3>
              <div className="flex-col">
                {/* <button type="submit" onClick={completeTransaction} disabled={isProcessing} className="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Complete Transaction</button> */}
                {strictDelete ? (
                  <div className="flex flex-col gap-2">
                    <p className="font-bold text-sm text-red-500">Type YES to confirm your action</p>
                    <input id="strict_confirm_input" type="text" className="bg-gray-50 border border-red-300 text-gray-900 text-lg rounded-lg focus:ring-red-500 focus:outline-red-500 outline-2 focus:ring-2 focus:ring-inset focus:border-red-500 block w-full p-2.5" required></input>
                  </div>
                ) : null }
                <div className="flex flex-col-reverse space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4 mt-1 sm:mt-5 justify-between">
                  <button
                    onClick={() => {
                      SetDeleteModalView(false);
                    }}
                    id="authCancelButton"
                    className="transition-color duration-100 mt-4 sm:mt-0 w-full text-slate-800 bg-white-700 ring-slate-800 ring-inset ring-2 hover:bg-slate-100 focus:bg-slate-200 focus:ring-4 focus:outline-none focus:ring-slate-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                    disabled={confirmProcessing}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={async () => {
                      if (strictDelete && document.getElementById("strict_confirm_input").value !== "YES") {
                        document.getElementById("strict_confirm_input").focus();
                        setShowStrictError(true);
                        return;
                      }

                      setConfirmProcessing(true);
                      let confirmResponse = await ConfirmHandler(ConfirmHandlerArgs);
                      if (!confirmResponse) {
                        setConfirmProcessing(false);
                        setDisplayError(true);
                        return;
                      }
                    }}
                    disabled={confirmProcessing}
                    className="transition-color duration-100 w-full text-white bg-red-600 hover:bg-red-700 focus:ring-4 focus:outline-none focus:ring-red-300 focus:bg-red-900 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                  >
                    {confirmProcessing ? (
                      <div className="flex w-full h-5 justify-center items-center">
                        <Spinner.ThreeDots color="#fff" height="10" radius="4" />
                      </div>
                    ) : "Yes"}
                  </button>
                </div>
              </div>

              {/* <div className="space-y-6">
                          <div>
                              <label htmlFor="cid" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">CID</label>
                              <input id="cid" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white" value={Cookies.get("cid")} required disabled></input>
                          </div>
                          <div>
                              <label htmlFor="cvv_input" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">CVV</label>
                              <input id="cvv_input" type="number" pattern="\d*" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white" required></input> */}
              {/* <input className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white" placeholder="name@company.com" required></input> */}
              {/* </div>
                          
                          <button type="submit" onClick={completeTransaction} disabled={isProcessing} className="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Complete Transaction</button>
                      </div> */}
            </div>
          </div>
        </div>

        {WarningText ? (
          <div className="relative w-full max-w-md h-auto py-4">
            {/* <!-- Modal content --> */}
            {/* <div className="relative bg-white rounded-lg shadow dark:bg-gray-700"> */}
            <div className="relative bg-red-200 rounded-lg shadow-lg">
              {/* <button onClick={closeModal} type="button" className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white" data-modal-hide="authentication-modal"> */}
              {/* <button onClick={closeAuthenticationModal} type="button" className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center" data-modal-hide="authentication-modal">
                        <svg onClick={closeAuthenticationModal} aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                    </button> */}
              <div className="p-4">
                {/* <h3 className="mb-4 text-xl font-medium text-gray-900 dark:text-white">Authenticate Card</h3> */}
                <div className="flex flex-row space-x-1 content-center">
                  <Icon.AlertTriangle className="w-6 h-6 text-red-800" />
                  <h3 className="mb-1 text-1xl font-bold text-red-800">
                    This Action is Irreversible
                  </h3>
                </div>
                <p className="text-xs font-normal text-blue-red mt-2">
                  {WarningText !== undefined ? (
                    WarningText
                  ) : (
                    <Skeleton />
                  )}
                </p>

                {/* <p className="mb-4 text-sm font-semibold text-gray-500 dark:text-white bg-red-500 rounded-lg p-3">Transaction Failed: Insufficient Balance</p> */}
                {/* <p className="mb-4 text-sm font-semibold text-gray-500 dark:text-red-500">Transaction Failed: Insufficient Balance</p> */}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </Modal>
  )
}